import { PDFDocument, rgb } from 'pdf-lib'

export class Img2PdfApp {
  constructor() {
    this.container = null;
    this.selectedFiles = [];
    this.settings = this.getDefaultSettings();
  }

  getDefaultSettings() {
    return {
      // Main settings (visible by default)
      pageFormat: 'A4',
      pageOrientation: 'portrait',
      imagesPerPage: 1,
      imageLayout: 'fit',
      flow: 'auto',
      
      // Advanced settings (hidden by default)
      quality: 'high',
      marginTop: 50,
      marginRight: 50,
      marginBottom: 50,
      marginLeft: 50,
      spacing: 10,
      backgroundColor: null,
      addImageLabels: false,
      labelPosition: 'bottom',
      
      // Metadata
      title: 'Images PDF',
      author: '',
      subject: 'Converted Images',
      keywords: ['images', 'pdf'],
      creator: 'Images to PDF Converter',
      producer: 'Images to PDF Converter'
    };
  }

  init(container) {
    this.container = container;
    this.render();
    this.setupEventListeners();
  }

  render() {
    this.container.innerHTML = `
      <div class="container">
        <div class="img2pdf-app">
          <!-- File Upload Section -->
          <div class="upload-section">
            <div class="upload-area" id="upload-area">
              <div class="upload-icon">📁</div>
              <h3>Select Images</h3>
              <p>Choose PNG, JPG, or JPEG files to convert</p>
              <button class="upload-button" id="file-select-btn">
                <span>📎 Choose Files</span>
              </button>
              <input type="file" id="file-input" accept="image/*" multiple style="display: none;">
              <div class="upload-hint">Or drag and drop images here</div>
            </div>
            
            <div class="selected-files" id="selected-files" style="display: none;">
              <h4>Selected Images:</h4>
              <div class="files-list" id="files-list"></div>
              <button class="clear-files" id="clear-files">🗑️ Clear All</button>
            </div>
          </div>

          <!-- Settings Section -->
          <div class="settings-section">
            <h3>Settings</h3>
            
            <!-- Main Settings -->
            <div class="settings-group main-settings">
              <div class="setting-row">
                <label for="page-format">Page Format:</label>
                <select id="page-format" class="setting-input">
                  <option value="A4">A4 (210×297mm)</option>
                  <option value="A3">A3 (297×420mm)</option>
                  <option value="Letter">Letter (8.5×11")</option>
                  <option value="Legal">Legal (8.5×14")</option>
                  <option value="Tabloid">Tabloid (11×17")</option>
                </select>
              </div>

              <div class="setting-row">
                <label for="page-orientation">Orientation:</label>
                <select id="page-orientation" class="setting-input">
                  <option value="portrait">Portrait</option>
                  <option value="landscape">Landscape</option>
                </select>
              </div>

              <div class="setting-row">
                <label for="images-per-page">Images per Page:</label>
                <input type="number" id="images-per-page" class="setting-input" min="1" max="9" value="1">
              </div>

              <div class="setting-row">
                <label for="image-layout">Image Layout:</label>
                <select id="image-layout" class="setting-input">
                  <option value="fit">Fit (maintain aspect ratio)</option>
                  <option value="fill">Fill (may crop)</option>
                  <option value="stretch">Stretch (may distort)</option>
                  <option value="center">Center (original size)</option>
                  <option value="original">Original (exact size)</option>
                </select>
              </div>

              <div class="setting-row">
                <label for="flow">Layout Flow:</label>
                <select id="flow" class="setting-input">
                  <option value="auto">Auto (grid layout)</option>
                  <option value="vertical">Vertical (stack images)</option>
                  <option value="horizontal">Horizontal (side by side)</option>
                </select>
              </div>
            </div>

            <!-- Advanced Settings Toggle -->
            <button class="advanced-toggle" id="advanced-toggle">
              <span>⚙️ Advanced Settings</span>
              <span class="toggle-icon">▼</span>
            </button>

            <!-- Advanced Settings (Hidden by default) -->
            <div class="settings-group advanced-settings" id="advanced-settings" style="display: none;">
              <div class="setting-row">
                <label for="quality">Quality:</label>
                <select id="quality" class="setting-input">
                  <option value="high">High</option>
                  <option value="medium">Medium</option>
                  <option value="low">Low</option>
                </select>
              </div>

              <div class="margins-group">
                <label>Margins (points):</label>
                <div class="margins-inputs">
                  <input type="number" id="margin-top" placeholder="Top" value="50" min="0">
                  <input type="number" id="margin-right" placeholder="Right" value="50" min="0">
                  <input type="number" id="margin-bottom" placeholder="Bottom" value="50" min="0">
                  <input type="number" id="margin-left" placeholder="Left" value="50" min="0">
                </div>
              </div>

              <div class="setting-row">
                <label for="spacing">Image Spacing:</label>
                <input type="number" id="spacing" class="setting-input" min="0" value="10">
              </div>

              <div class="setting-row">
                <label for="add-labels">Add Image Labels:</label>
                <input type="checkbox" id="add-labels" class="setting-checkbox">
              </div>

              <div class="setting-row">
                <label for="label-position">Label Position:</label>
                <select id="label-position" class="setting-input">
                  <option value="bottom">Bottom</option>
                  <option value="top">Top</option>
                </select>
              </div>

              <!-- Metadata -->
              <div class="metadata-group">
                <h4>PDF Metadata</h4>
                <input type="text" id="pdf-title" placeholder="Document Title" value="Images PDF">
                <input type="text" id="pdf-author" placeholder="Author">
                <input type="text" id="pdf-subject" placeholder="Subject" value="Converted Images">
              </div>
            </div>
          </div>

          <!-- Convert Section -->
          <div class="convert-section">
            <button class="convert-button" id="convert-button" disabled>
              <span class="convert-icon">🔄</span>
              <span class="convert-text">Convert to PDF</span>
            </button>
            
            <div class="progress-section" id="progress-section" style="display: none;">
              <div class="progress-bar">
                <div class="progress-fill" id="progress-fill"></div>
              </div>
              <div class="progress-text" id="progress-text">Converting...</div>
            </div>
          </div>
        </div>
      </div>
    `;
  }
  setupEventListeners() {
    const fileInput = document.getElementById('file-input');
    const fileSelectBtn = document.getElementById('file-select-btn');
    const uploadArea = document.getElementById('upload-area');
    const clearFilesBtn = document.getElementById('clear-files');
    const convertBtn = document.getElementById('convert-button');
    const advancedToggle = document.getElementById('advanced-toggle');

    // File selection
    fileSelectBtn.addEventListener('click', () => fileInput.click());
    fileInput.addEventListener('change', (e) => this.handleFileSelection(e.target.files));

    // Drag and drop
    uploadArea.addEventListener('dragover', this.handleDragOver.bind(this));
    uploadArea.addEventListener('drop', this.handleFileDrop.bind(this));
    uploadArea.addEventListener('dragleave', this.handleDragLeave.bind(this));

    // Clear files
    clearFilesBtn.addEventListener('click', () => this.clearFiles());

    // Convert button
    convertBtn.addEventListener('click', () => this.convertToPDF());

    // Advanced settings toggle
    advancedToggle.addEventListener('click', () => this.toggleAdvancedSettings());

    // Settings change listeners
    this.setupSettingsListeners();
  }

  setupSettingsListeners() {
    // Main settings
    document.getElementById('page-format').addEventListener('change', (e) => {
      this.settings.pageFormat = e.target.value;
    });

    document.getElementById('page-orientation').addEventListener('change', (e) => {
      this.settings.pageOrientation = e.target.value;
    });

    document.getElementById('images-per-page').addEventListener('change', (e) => {
      this.settings.imagesPerPage = parseInt(e.target.value);
    });

    document.getElementById('image-layout').addEventListener('change', (e) => {
      this.settings.imageLayout = e.target.value;
    });

    document.getElementById('flow').addEventListener('change', (e) => {
      this.settings.flow = e.target.value;
    });

    // Advanced settings
    document.getElementById('quality').addEventListener('change', (e) => {
      this.settings.quality = e.target.value;
    });

    ['margin-top', 'margin-right', 'margin-bottom', 'margin-left'].forEach(id => {
      document.getElementById(id).addEventListener('change', (e) => {
        const property = id.replace('-', '').replace('margin', 'margin');
        const propertyName = id.replace('-', '').charAt(0).toUpperCase() + id.replace('-', '').slice(1).replace('margin', 'margin');
        this.settings[propertyName] = parseInt(e.target.value) || 0;
      });
    });

    document.getElementById('spacing').addEventListener('change', (e) => {
      this.settings.spacing = parseInt(e.target.value) || 0;
    });

    document.getElementById('add-labels').addEventListener('change', (e) => {
      this.settings.addImageLabels = e.target.checked;
    });

    document.getElementById('label-position').addEventListener('change', (e) => {
      this.settings.labelPosition = e.target.value;
    });

    // Metadata
    document.getElementById('pdf-title').addEventListener('change', (e) => {
      this.settings.title = e.target.value;
    });

    document.getElementById('pdf-author').addEventListener('change', (e) => {
      this.settings.author = e.target.value;
    });

    document.getElementById('pdf-subject').addEventListener('change', (e) => {
      this.settings.subject = e.target.value;
    });
  }

  handleFileSelection(files) {
    const validFiles = Array.from(files).filter(file => {
      return file.type.startsWith('image/') && 
             ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
    });

    if (validFiles.length === 0) {
      this.showError('Please select valid image files (PNG, JPG, JPEG)');
      return;
    }

    this.selectedFiles = validFiles;
    this.updateFilesList();
    this.updateConvertButton();
  }

  handleDragOver(e) {
    e.preventDefault();
    e.stopPropagation();
    e.currentTarget.classList.add('drag-over');
  }

  handleDragLeave(e) {
    e.preventDefault();
    e.stopPropagation();
    e.currentTarget.classList.remove('drag-over');
  }

  handleFileDrop(e) {
    e.preventDefault();
    e.stopPropagation();
    e.currentTarget.classList.remove('drag-over');
    
    const files = e.dataTransfer.files;
    this.handleFileSelection(files);
  }

  updateFilesList() {
    const filesListContainer = document.getElementById('selected-files');
    const filesList = document.getElementById('files-list');

    if (this.selectedFiles.length === 0) {
      filesListContainer.style.display = 'none';
      return;
    }

    filesListContainer.style.display = 'block';
    filesList.innerHTML = '';

    this.selectedFiles.forEach((file, index) => {
      const fileItem = document.createElement('div');
      fileItem.className = 'file-item';
      fileItem.innerHTML = `
        <div class="file-info">
          <span class="file-name">${file.name}</span>
          <span class="file-size">${this.formatFileSize(file.size)}</span>
        </div>
        <button class="remove-file" data-index="${index}">×</button>
      `;
      
      fileItem.querySelector('.remove-file').addEventListener('click', () => {
        this.removeFile(index);
      });
      
      filesList.appendChild(fileItem);
    });
  }
  removeFile(index) {
    this.selectedFiles.splice(index, 1);
    this.updateFilesList();
    this.updateConvertButton();
  }

  clearFiles() {
    this.selectedFiles = [];
    this.updateFilesList();
    this.updateConvertButton();
  }

  updateConvertButton() {
    const convertBtn = document.getElementById('convert-button');
    convertBtn.disabled = this.selectedFiles.length === 0;
  }

  toggleAdvancedSettings() {
    const advancedSettings = document.getElementById('advanced-settings');
    const toggleIcon = document.querySelector('.toggle-icon');
    
    if (advancedSettings.style.display === 'none') {
      advancedSettings.style.display = 'block';
      toggleIcon.textContent = '▲';
    } else {
      advancedSettings.style.display = 'none';
      toggleIcon.textContent = '▼';
    }
  }

  async convertToPDF() {
    if (this.selectedFiles.length === 0) return;

    try {
      this.showProgress('Initializing PDF...');
      
      const pdfDoc = await PDFDocument.create();
      
      // Set metadata
      pdfDoc.setTitle(this.settings.title);
      pdfDoc.setAuthor(this.settings.author);
      pdfDoc.setSubject(this.settings.subject);
      pdfDoc.setKeywords(this.settings.keywords);
      pdfDoc.setCreator(this.settings.creator);
      pdfDoc.setProducer(this.settings.producer);
      pdfDoc.setCreationDate(new Date());

      const pageSize = this.getPageSize();
      const contentArea = {
        width: pageSize.width - this.settings.marginLeft - this.settings.marginRight,
        height: pageSize.height - this.settings.marginTop - this.settings.marginBottom
      };

      // Group images based on imagesPerPage setting
      const imageGroups = this.groupImages(this.selectedFiles);
      
      for (let groupIndex = 0; groupIndex < imageGroups.length; groupIndex++) {
        const imageGroup = imageGroups[groupIndex];
        
        this.updateProgress(
          `Processing page ${groupIndex + 1} of ${imageGroups.length}...`,
          (groupIndex / imageGroups.length) * 0.8
        );

        await this.addPageWithImages(pdfDoc, imageGroup, pageSize, contentArea);
      }

      this.updateProgress('Generating PDF file...', 0.9);

      // Save PDF
      const pdfBytes = await pdfDoc.save();
      
      this.updateProgress('Download ready!', 1.0);
      
      // Download the file
      this.downloadFile(pdfBytes, 'converted-images.pdf');
      
      this.hideProgress();
      this.showSuccess('PDF created successfully!');

    } catch (error) {
      console.error('Error converting to PDF:', error);
      this.hideProgress();
      this.showError(`Conversion failed: ${error.message}`);
    }
  }

  async addPageWithImages(pdfDoc, imageFiles, pageSize, contentArea) {
    const page = pdfDoc.addPage([pageSize.width, pageSize.height]);

    // Set background color if specified
    if (this.settings.backgroundColor) {
      page.drawRectangle({
        x: 0,
        y: 0,
        width: pageSize.width,
        height: pageSize.height,
        color: rgb(
          this.settings.backgroundColor.r,
          this.settings.backgroundColor.g,
          this.settings.backgroundColor.b
        )
      });
    }

    // Calculate layout for multiple images
    const layout = this.calculateImageLayout(imageFiles.length, contentArea);

    for (let i = 0; i < imageFiles.length; i++) {
      const imageFile = imageFiles[i];
      const imageArea = layout[i];

      await this.addImageToPage(pdfDoc, page, imageFile, imageArea, pageSize);
    }
  }

  async addImageToPage(pdfDoc, page, imageFile, imageArea, pageSize) {
    const arrayBuffer = await imageFile.arrayBuffer();
    let image;
    
    if (imageFile.type === 'image/png') {
      image = await pdfDoc.embedPng(arrayBuffer);
    } else if (imageFile.type === 'image/jpeg' || imageFile.type === 'image/jpg') {
      image = await pdfDoc.embedJpg(arrayBuffer);
    } else {
      throw new Error(`Unsupported image format: ${imageFile.type}`);
    }

    // Get original image dimensions
    const imageDims = image.scale(1);
    
    // Calculate scaled dimensions based on layout option
    const scaledDims = this.calculateImageDimensions(
      imageDims, 
      imageArea, 
      this.settings.imageLayout
    );

    // Calculate position (center the image in its allocated area)
    const x = imageArea.x + (imageArea.width - scaledDims.width) / 2;
    const y = imageArea.y + (imageArea.height - scaledDims.height) / 2;

    // Draw the image
    page.drawImage(image, {
      x: x,
      y: y,
      width: scaledDims.width,
      height: scaledDims.height
    });

    // Add image label if requested
    if (this.settings.addImageLabels) {
      await this.addImageLabel(page, imageFile.name, imageArea, pageSize, pdfDoc);
    }
  }
  async addImageLabel(page, fileName, imageArea, pageSize, pdfDoc) {
    const font = await pdfDoc.embedFont('Helvetica');
    const fontSize = 10;
    
    let labelY;
    if (this.settings.labelPosition === 'top') {
      labelY = imageArea.y + imageArea.height + 5;
    } else {
      labelY = imageArea.y - 15;
    }

    // Center the label horizontally in the image area
    const textWidth = font.widthOfTextAtSize(fileName, fontSize);
    const labelX = imageArea.x + (imageArea.width - textWidth) / 2;

    page.drawText(fileName, {
      x: Math.max(this.settings.marginLeft, labelX),
      y: Math.max(this.settings.marginBottom, labelY),
      size: fontSize,
      font: font,
      color: rgb(0, 0, 0)
    });
  }

  calculateImageDimensions(originalDims, targetArea, layout) {
    switch (layout) {
      case 'fit':
        // Scale to fit within area while maintaining aspect ratio
        const scaleX = targetArea.width / originalDims.width;
        const scaleY = targetArea.height / originalDims.height;
        const scale = Math.min(scaleX, scaleY);
        return {
          width: originalDims.width * scale,
          height: originalDims.height * scale
        };

      case 'fill':
        // Scale to fill area while maintaining aspect ratio (may crop)
        const fillScaleX = targetArea.width / originalDims.width;
        const fillScaleY = targetArea.height / originalDims.height;
        const fillScale = Math.max(fillScaleX, fillScaleY);
        return {
          width: Math.min(originalDims.width * fillScale, targetArea.width),
          height: Math.min(originalDims.height * fillScale, targetArea.height)
        };

      case 'stretch':
        // Stretch to exactly fit area (may distort aspect ratio)
        return {
          width: targetArea.width,
          height: targetArea.height
        };

      case 'center':
        // Use original size, centered (may be clipped if too large)
        return {
          width: Math.min(originalDims.width, targetArea.width),
          height: Math.min(originalDims.height, targetArea.height)
        };

      case 'original':
        // Use exact original size
        return {
          width: originalDims.width,
          height: originalDims.height
        };

      default:
        return this.calculateImageDimensions(originalDims, targetArea, 'fit');
    }
  }

  calculateImageLayout(imageCount, contentArea) {
    if (imageCount === 1) {
      // Single image takes full content area
      return [{
        x: this.settings.marginLeft,
        y: this.settings.marginBottom,
        width: contentArea.width,
        height: contentArea.height
      }];
    }

    // Calculate layout based on flow option
    switch (this.settings.flow.toLowerCase()) {
      case 'vertical':
        return this.calculateVerticalLayout(imageCount, contentArea);
      case 'horizontal':
        return this.calculateHorizontalLayout(imageCount, contentArea);
      case 'auto':
      default:
        return this.calculateGridLayout(imageCount, contentArea);
    }
  }

  calculateVerticalLayout(imageCount, contentArea) {
    const layouts = [];
    const imageHeight = (contentArea.height - (imageCount - 1) * this.settings.spacing) / imageCount;
    const imageWidth = contentArea.width;

    for (let i = 0; i < imageCount; i++) {
      layouts.push({
        x: this.settings.marginLeft,
        y: this.settings.marginBottom + (imageCount - 1 - i) * (imageHeight + this.settings.spacing),
        width: imageWidth,
        height: imageHeight
      });
    }

    return layouts;
  }

  calculateHorizontalLayout(imageCount, contentArea) {
    const layouts = [];
    const imageWidth = (contentArea.width - (imageCount - 1) * this.settings.spacing) / imageCount;
    const imageHeight = contentArea.height;

    for (let i = 0; i < imageCount; i++) {
      layouts.push({
        x: this.settings.marginLeft + i * (imageWidth + this.settings.spacing),
        y: this.settings.marginBottom,
        width: imageWidth,
        height: imageHeight
      });
    }

    return layouts;
  }

  calculateGridLayout(imageCount, contentArea) {
    const layouts = [];
    
    // Calculate grid layout for multiple images
    const cols = Math.ceil(Math.sqrt(imageCount));
    const rows = Math.ceil(imageCount / cols);
    
    const imageWidth = (contentArea.width - (cols - 1) * this.settings.spacing) / cols;
    const imageHeight = (contentArea.height - (rows - 1) * this.settings.spacing) / rows;

    for (let i = 0; i < imageCount; i++) {
      const col = i % cols;
      const row = Math.floor(i / cols);
      
      layouts.push({
        x: this.settings.marginLeft + col * (imageWidth + this.settings.spacing),
        y: this.settings.marginBottom + (rows - 1 - row) * (imageHeight + this.settings.spacing),
        width: imageWidth,
        height: imageHeight
      });
    }

    return layouts;
  }
  groupImages(imageFiles) {
    const groups = [];
    for (let i = 0; i < imageFiles.length; i += this.settings.imagesPerPage) {
      groups.push(imageFiles.slice(i, i + this.settings.imagesPerPage));
    }
    return groups;
  }

  getPageSize() {
    const pageSizes = {
      A4: { width: 595, height: 842 },
      A3: { width: 842, height: 1191 },
      Letter: { width: 612, height: 792 },
      Legal: { width: 612, height: 1008 },
      Tabloid: { width: 792, height: 1224 }
    };

    let size = pageSizes[this.settings.pageFormat] || pageSizes.A4;

    // Swap dimensions for landscape
    if (this.settings.pageOrientation === 'landscape') {
      return { width: size.height, height: size.width };
    }
    
    return size;
  }

  downloadFile(data, filename) {
    const blob = new Blob([data], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  showProgress(message) {
    const progressSection = document.getElementById('progress-section');
    const convertButton = document.getElementById('convert-button');
    
    progressSection.style.display = 'block';
    convertButton.disabled = true;
    
    this.updateProgress(message, 0);
  }

  updateProgress(message, progress) {
    const progressText = document.getElementById('progress-text');
    const progressFill = document.getElementById('progress-fill');
    
    progressText.textContent = message;
    progressFill.style.width = `${Math.round(progress * 100)}%`;
  }

  hideProgress() {
    const progressSection = document.getElementById('progress-section');
    const convertButton = document.getElementById('convert-button');
    
    setTimeout(() => {
      progressSection.style.display = 'none';
      convertButton.disabled = this.selectedFiles.length === 0;
    }, 2000);
  }

  showSuccess(message) {
    this.showNotification(message, 'success');
  }

  showError(message) {
    this.showNotification(message, 'error');
  }

  showNotification(message, type) {
    // Create notification element
    const notification = document.createElement('div');
    notification.className = `notification notification-${type}`;
    notification.textContent = message;
    
    // Add to container
    this.container.appendChild(notification);
    
    // Auto remove after 5 seconds
    setTimeout(() => {
      if (notification.parentNode) {
        notification.parentNode.removeChild(notification);
      }
    }, 5000);
  }

  destroy() {
    // Clean up any resources if needed
    this.selectedFiles = [];
    if (this.container) {
      this.container.innerHTML = '';
    }
  }
}